/* eslint-disable import/prefer-default-export */
export const breakpoints = [320, 768, 1024, 1280];

export const mediaQueries = breakpoints.map(
  (bp) => `@media (min-width: ${bp}px)`
);
